import { FC } from 'react'
import { IconPaths } from '_metronic/helpers/enumsUI'
import { useT } from '_metronic/i18n/Metronici18n'
import { formatDateTime } from '../../../../../../../_metronic/helpers/crud-helper/helpers'
import { TriagemRiscoBadge } from '../../../../../../components/TriagemRisco/TriagemRiscoBadge'
import { TriagemTag } from '../../../../../../components/TriagemRisco/TriagemTag'
import { TriagemItem } from '../../../../triagem/core/_models'
import { TriagemDetalhe } from './TriagemDetalhe'
import { rotuloOrigem } from './triagemTextos'

type TriagemHistoricoItemProps = {
  triagem: TriagemItem
  aberta: boolean
  naoVista?: boolean
  onAlternar: () => void
}

/** Uma triagem do histórico: cabeçalho sempre visível e o detalhe sob demanda (AC8). */
export const TriagemHistoricoItem: FC<TriagemHistoricoItemProps> = ({
  triagem,
  aberta,
  naoVista,
  onAlternar,
}) => {
  const { t } = useT()
  return (
    <li className='border-top py-2'>
      <button
        type='button'
        className='btn btn-link text-start w-100 p-0'
        aria-expanded={aberta}
        onClick={onAlternar}
      >
        <span className='d-flex flex-wrap align-items-center gap-2'>
          <span className='fw-bold'>{t('triagem.numero', { sequencia: triagem.sequencia })}</span>
          <TriagemRiscoBadge cor={triagem.corEfetiva} titulo={t('triagem.rotulo.cor_efetiva')} />
          {triagem.vigente && <TriagemTag texto={t('triagem.vigente')} />}
          {naoVista && <TriagemTag texto={t('triagem.nova')} icone={IconPaths.Bell} />}
        </span>
        <span className='d-block text-muted'>
          {rotuloOrigem(t, triagem.origem)} — {formatDateTime(triagem.dtCriacao)} —{' '}
          {t('triagem.revisada')}: {triagem.revisada ? t('triagem.sim') : t('triagem.nao')}
        </span>
      </button>
      {aberta && <TriagemDetalhe triagem={triagem} />}
    </li>
  )
}
